module.exports = __webpack_public_path__ + "img/BRCA2_CD8Tex.4347194c.png";